import { render, staticRenderFns } from "./Instruction.container.vue?vue&type=template&id=61571b8a&scoped=true&"
import script from "./Instruction.container.vue?vue&type=script&lang=js&"
export * from "./Instruction.container.vue?vue&type=script&lang=js&"
import style0 from "./Instruction.container.vue?vue&type=style&index=0&id=61571b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61571b8a",
  null
  
)

export default component.exports